import React from "react";
import Nav from "../../components/Navbar/Nav";
import Banner from "../../components/Banner/Banner";
import requests from "../../api/Requests";
import Row from "../../components/Movies/Row";

function TVShows() {
	return (
		<div className="homeScreen">
			<Nav />
			<Banner fetchUrl={requests.fetchNetflixOriginals} />
			<div className="row-container">
				<Row title="Popular TV Shows" fetchUrl={requests.fetchPopularTV} isLargeRow />
				<Row title="Top Rated" fetchUrl={requests.fetchTopRatedTV} isLargeRow />
				<Row title="On The Air" fetchUrl={requests.fetchOnTheAir} isLargeRow />
				<Row title="Airing Today" fetchUrl={requests.fetchAiringToday} isLargeRow />
				<Row title="Netflix Originals" fetchUrl={requests.fetchNetflixOriginals} isLargeRow />
				<Row title="Action & Adventure" fetchUrl={requests.fetchActionTV} isLargeRow />
				<Row title="Comedy" fetchUrl={requests.fetchComedyTV} isLargeRow />
				<Row title="Crime" fetchUrl={requests.fetchCrimeTV} isLargeRow />
				<Row title="Documentary" fetchUrl={requests.fetchDocumentaryTV} isLargeRow />
				<Row title="Drama" fetchUrl={requests.fetchDramaTV} isLargeRow />
				<Row title="Mystery" fetchUrl={requests.fetchMysteryTV} isLargeRow />
				<Row title="Sci-Fi & Fantasy" fetchUrl={requests.fetchSciFiTV} isLargeRow />
			</div>
		</div>
	);
}

export default TVShows;
